import i18n from 'i18n';
import { applyMomentLocale } from 'i18n/dateLocale';

const formatDateLocaleES = (): void => {
  applyMomentLocale(i18n.language, { startWeekOnMonday: true });
};

export default formatDateLocaleES;
